
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Emit, Prop} from 'vue-property-decorator';
  import {TeamModel} from '@/models/team.model';
  import {teamModule, userModule} from '@/utils/store-acessor';
  import {UserModel} from '@/models/user.model';

  @Component({})
  export default class TeamCard extends Vue {
    @Prop({required: false, default: true}) showActionsButtons!: boolean;
    @Prop({required: false, default: true}) showInvitationButton!: boolean;
    @Prop({required: true}) team!: TeamModel;
    @Prop({required: true}) maxTitleLength!: number;
    @Prop({required: false, default: false}) loading!: boolean;
    @userModule.Getter('user') currentUser!: UserModel;
    @teamModule.Getter('isOwner') isOwner!: (
            team: TeamModel,
            user: UserModel
    ) => boolean;

    get hasResponsible(): boolean {
      return !!this.team?.responsible
    }

    @Emit()
    onTeamSelected(): TeamModel {
      return this.team;
    }

    @Emit()
    sendInvitation(): TeamModel {
      return this.team;
    }

    @Emit()
    onDestroy(): TeamModel {
      return this.team;
    }

    @Emit()
    openToEdit(): TeamModel {
      return this.team;
    }

    formatName = (user: UserModel): string => `${user.first_name} ${user.last_name}`;

    formatTitle(): string {
      const teamTitle = this.team.name.slice(0, this.maxTitleLength);
      return this.team.name.length > this.maxTitleLength
              ? `${teamTitle}...`
              : this.team.name;
    }

    get formatMembersBanner(): string {
      const teamLimit: number = this.team?.max_members || 0;
      const teamCount = this.team?.count_members || 0;
      const emptySlot = teamLimit - teamCount - 1;
      if (emptySlot > 0) {
        return this.$t('team.labels.open_member_slots', {members: teamCount + 1, slots: emptySlot}).toString();
      } else {
        return this.$t('team.labels.full_members', {members: teamCount + 1}).toString();
      }
    }
  }
